module.exports = __webpack_public_path__ + "img/Bikendi_Cercle.87532dcb.png";